<template scope="user">
  <div class>
    <v-toolbar class="mb-3" elevation="0">
      <v-toolbar-title>Configuration des emails</v-toolbar-title>
      <v-spacer></v-spacer>
      <add-mail @addMail="getMailings()" :edit="editModel" />
    </v-toolbar>
    <v-card elevation="0">
      <v-card-text>
        <v-data-table :items="mailings" :headers="headers">
          <template v-slot:item="{item}">
            <tr>
              <td>{{item.key}}</td>
              <td>{{item.name}}</td>
              <td>{{item.subject}}</td>
              <td>{{item.mandrillTemplate}}</td>
              <td>
                <v-menu bottom left>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="editMail(item)">
                      <v-list-item-title>Modifier</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import AddMail from "../../components/mailing/AddMail";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Mailings",
  components: {
    AddMail
  },
  mounted() {
    this.getMailings();
  },
  computed: {
    ...mapGetters("options", ["mailings"])
  },
  data() {
    return {
      headers: [
        { text: "Clé", value: "key" },
        { text: "Nom", value: "name" },
        { text: "Sujet", value: "subject" },
        { text: "Template", value: "mandrillTemplate" },
        { text: "", value: "actions" }
      ],
      editModel: null
    };
  },
  methods: {
    ...mapActions("options", ["getMailings"]),
    editMail(mail) {
      this.editModel = mail;
    },
    reload() {
      this.editModel = null;
      this.getMailings();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>